import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { Block, Inline } from '@contentful/rich-text-types';
import type { Sys } from 'src/types/contentful-sdk-compat';
import { Stack } from 'src/components-v2/Layout';
import { RichTextSwitch } from 'src/containers';

interface TextStackProps {
  sys: Sys;
  fields: {
    body: Block | Inline;
  };
}

export const TextStack: React.FC<TextStackProps> = ({ sys, fields }) => {
  const inspectorProps = useContentfulInspectorMode({
    entryId: sys?.id,
  });
  return (
    <Stack
      direction={{ xs: 'row', md: 'column' }}
      {...inspectorProps({ fieldId: 'body' })}
    >
      <Stack
        gap={{
          xs: 1,
          md: 3,
        }}
        sx={{
          '& p:nth-last-of-type(1):empty': {
            display: 'none',
          },
          mb: '32px',
        }}
      >
        <RichTextSwitch
          sys={sys}
          content={fields.body}
          nodes={{
            p: {
              theme: 'web 3.0',
              variant: 'P1 Regular',
              component: 'p',
              fieldId: 'body',
            },
            h2: {
              variant: 'h3',
              component: 'h3',
            },
            h3: {
              variant: 'h3',
            },
            h6: {
              variant: 'h6',
              component: 'h2',
              className: 'eyebrow-heading',
            },
          }}
        />
      </Stack>
    </Stack>
  );
};
